import { createClient } from "@sanity/client";

export default createClient({
    useCdn: false,
    apiVersion: process.env.REACT_APP_SANITY_API_VERSION,
    token: process.env.REACT_APP_SANITY_TOKEN,
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID, // find this at manage.sanity.io or in your sanity.json
    dataset: process.env.REACT_APP_SANITY_DATASET, // this is from those question during 'sanity init'
});